@if (isLink()) {
  @if (!isExternalUrl()) {
    <a
      [ngStyle]="buttonStyle() | getStyle"
      [queryParams]="params() ?? {}"
      [routerLink]="[url()]"
      class="button-link button-{{ theme() | lowercase }} size-{{ size() | lowercase }}">
      <div *ngTemplateOutlet="buttonContent"></div>
    </a>
  } @else {
    <a
      [href]="url()"
      [ngStyle]="buttonStyle() | getStyle"
      class="button-link button-{{ theme() | lowercase }} size-{{ size() | lowercase }}"
      rel="noopener noreferrer"
      target="_blank">
      <div *ngTemplateOutlet="buttonContent"></div>
    </a>
  }
} @else {
  <button
    (click)="submit()"
    [disabled]="isDisabled()"
    [ngStyle]="buttonStyle() | getStyle"
    class="button button-{{ theme() | lowercase }} size-{{ size() | lowercase }}">
    <div *ngTemplateOutlet="buttonContent"></div>
  </button>
}
<ng-template #button>
  <button
    (click)="submit()"
    [disabled]="isDisabled()"
    [ngStyle]="buttonStyle() | getStyle"
    class="button button-{{ theme() | lowercase }} size-{{ size() | lowercase }}">
    <div *ngTemplateOutlet="buttonContent"></div>
  </button>
</ng-template>
<ng-template #buttonContent>
  <span class="button-content">
    @if (iconName() && iconPosition() === "LEFT") {
      <ng-container *ngTemplateOutlet="iconOrSpinner" />
    }
    {{ label() }}
    @if (iconName() && iconPosition() === "RIGHT") {
      <ng-container *ngTemplateOutlet="iconOrSpinner" />
    }
  </span>
</ng-template>
<ng-template #iconOrSpinner>
  @if (isLoading()) {
    <div class="loading">
      <div class="spinner"></div>
    </div>
  } @else {
    <i [color]="iconColor()" [iconName]="iconName()" [size]="iconSize()"></i>
  }
</ng-template>
